import axios from "axios";

const URL = "https://quanlycudan.azurewebsites.net/api";
const loginService = (payload) => axios.post(`${URL}//Users/authenticate`, payload);

export {
    loginService,
}